<template>
  <div>
    <h4 class="" style="font-weight: 500; margin-bottom: 0;">Package Selection</h4>
    <hr>
    <div v-if="!user.selector5">
      <button class="mylisting-button dark-button" @click="showPackageSelectionModal()">Select Package</button>
    </div>
    <div v-if="user.selector5">
      <p>Package Selected: {{ user.selector5 }}</p>
      <!-- <button class="mylisting-button dark-button" @click="resetPackage()">Reset Package</button> -->
    </div>

    <modal name="package-selection-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="document">
          <!-- <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" alt="" class="center" style="width: 110px; padding-bottom: 10px;"> -->
          <h3 style="text-align: center;">Permanent Placement Package Proposal</h3>
          <hr>
          <p>We're looking forward to customizing our search for your family! As every client has their own preference in their involvement of their Nanny search, we wanted to provide you with two options. Upon your selection, we'll begin working within the appropriate package.</p>
          <p>Each package begins with our diligent screening process:</p>
          <ul>
            <li>Diligent review of Application</li>
            <li>Social Media Screening</li>
            <li>Phone Interview</li>
            <li>In-Person Interview</li>
            <li>Thorough Reference Checks</li>
            <li>Clear Criminal Record Check</li>
            <li>Clear Child Abuse Check</li>
            <li>Updated CPR/First Aid Level C</li>
            <li>Drivers Abstract</li>
          </ul>

          <hr>

          <h4 class="mt-4">Executive Search</h4>
          <p>Our most popular option, you are allowing us to use our expertise in this industry to present you with our very best choice. We've considered many Nanny profiles and are going to present you with our very best option considering your schedule, expectations, behaviour modification strategies, personality and more. If we had to choose a Nanny for your family, this is it! </p>
          <p style="font-style: italic;">Fine Print: Additional profiles can be presented upon request at $150.00/profile.</p>
          <p>Cost: $250</p>
          <button class="mylisting-button dark-button mb-2" @click="showConfirmPackageSelectionModal('Executive Search')">Select Executive Search</button>

          <hr>

          <h4 class="mt-4">Comprehensive Search</h4>
          <p>If you're interested in potentially viewing more than 1 Nanny profile, this is the right option for you! We will cultivate our search according to your requested schedule, expectations and experience and present you with <strong>up to</strong> 3 Nanny Profiles. These Nanny Profiles will be sent to you as they are prepared and are not guaranteed to be sent at the same time. </p>
          <p style="font-style: italic;">Fine Print: Up to date status of potential profiles will be made know in a timely fashion. Nanny Profiles cannot be held for a Client for longer than a 96 hour period. Following that time, the Nanny can be made available to other Clients. We suggest all Clients to interview the Nanny candidates as they are received. No full or partial refunds will be provided based on the number of Nanny profiles received. </p>
          <p>Cost: $500</p>
          <button class="mylisting-button dark-button" @click="showConfirmPackageSelectionModal('Comprehensive Search')">Select Comprehensive Search</button>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('change-password-modal')">Cancel</button>
      </div>
    </modal>

    <modal name="confirm-package-selection-modal" width="85%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Confirm Selection - {{ packageSelection }}</h2>
        <hr>
        <h5>I have read and am confident of the terms and conditions with the package chosen.</h5>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('confirm-package-selection-modal')">Cancel</button>
        <button class="mylisting-button dark-button" @click="selectPackage()" style="float: right;">Confirm Selection</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      packageSelection: '',
    }
  },
  methods: {
    showPackageSelectionModal() {
      this.$modal.show('package-selection-modal')
    },
    showConfirmPackageSelectionModal(packageSelection) {
      this.packageSelection = packageSelection
      this.$modal.show('confirm-package-selection-modal')
    },
    selectPackage() {
      axios.patch(`/api/people/${this.user.id}/`, {
        selector5: this.packageSelection,
        status: 'Package Selected',
      })
        .then(res => {
          console.log(res)
          this.$modal.hide('package-selection-modal')
          this.$modal.hide('confirm-package-selection-modal')
          this.$emit('userUpdated')
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetPackage() {
      axios.patch(`/api/people/${this.user.id}/`, {
        selector5: '',
        // status: 'Interview Complete',
      })
        .then(res => {
          console.log(res)
          this.$modal.hide('package-selection-modal')
          this.$modal.hide('confirm-package-selection-modal')
          this.$emit('userUpdated')
        })
        .catch(error => {
          console.log(error)
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employers/profile/PackageSelection.vue